import { deepLinkWebPath } from '@capsico/contracts';

const LOCAL = 'app.local';

/**
 * Maps a notification deep link (capsico://order/x) or its web path (/order/x) to the screen in
 * this app (/orders/x). Anything that is not an in-app path falls back to Home, so a message can
 * never send the customer to another site.
 */
export function appPathFor(linkOrPath: string | null | undefined): string {
  if (!linkOrPath) return '/';
  const raw = deepLinkWebPath(linkOrPath.trim());
  let url: URL;
  try {
    url = new URL(raw.startsWith('/') ? raw : `/${raw}`, `https://${LOCAL}`);
  } catch {
    return '/';
  }
  if (url.host !== LOCAL) return '/';
  const [head, id, sub] = url.pathname.split('/').filter(Boolean);
  const search = url.search;
  switch (head) {
    case undefined:
    case 'home':
      return search ? `/${search}` : '/';
    case 'order':
      return id
        ? `/orders/${encodeURIComponent(id)}${sub === 'rate' ? '?rate=1' : ''}`
        : '/account/orders';
    case 'restaurant':
      return id ? `/r/${encodeURIComponent(id)}${search}` : '/';
    case 'wallet':
      return '/account/wallet';
    case 'help':
      return id ? `/account/help/${encodeURIComponent(id)}` : '/account/help';
    case 'inbox':
      return '/account/inbox';
    case 'refer':
      return '/account/refer';
    case 'campus-pass':
      return '/account/campus-pass';
    case 'cart':
      return '/cart';
    case 'offers': {
      const code = url.searchParams.get('code');
      return code ? `/?offer=${encodeURIComponent(code)}` : '/';
    }
    default:
      return `${url.pathname}${search}`;
  }
}
